import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { AssignedOffersHttpClient } from './assigned-offers.http-client';
import { ReferralsAssignedOffersActions } from './assigned-offers.store';

@Injectable({ providedIn: 'root' })
export class ReferralsAssignedOffersEffects {
  public effects = createEffectFactory(ReferralsAssignedOffersActions, this.actions$);

  public fetch$ = this.effects(ReferralsAssignedOffersActions.fetch, ({ payload }) => {
    const { id, searchParams } = payload;
    return this.http.assignedOffersList(id, searchParams);
  });

  constructor(private http: AssignedOffersHttpClient, private actions$: Actions) {}
}
